import getDistanceBetweenTwoLocations from './getDistanceBetweenTwoLocations';

function vectorDistance(dx, dy) {
  return Math.sqrt(dx * dx + dy * dy);
}

function getLocationDistance(location1, location2) {
  var dx = location1.latitude - location2.latitude;
  var dy = location1.longitude - location2.longitude;

  return vectorDistance(dx, dy);
}

function getDistanceToTarget(target, location) {
  const locationPosition = {
    latitude: location.latitude,
    longitude: location.longitude,
  };

  return getDistanceBetweenTwoLocations(target, locationPosition);
}

function getLocationsWithoutTargetLocation(locations, targetLocation) {
  return locations.reduce((remainLocations, location) => {
    if (location.code === targetLocation.code) return remainLocations;
    return [...remainLocations, location];
  }, []);
}

function updateLocationsWithDistancesToTarget(locations, targetLocation) {
  const locationsWithoutTarget = getLocationsWithoutTargetLocation(locations, targetLocation);
  return locationsWithoutTarget.reduce(
    (closestLocations, location) => {
      const locationIndexInClosestLocations = closestLocations.findIndex(
        closestLocation => closestLocation.code === location.code,
      );
      if (locationIndexInClosestLocations >= 0) {
        closestLocations[locationIndexInClosestLocations].distanceInKm = getDistanceToTarget(targetLocation, location);
        return closestLocations;
      }

      const currentDistance = getLocationDistance(location, targetLocation);
      const biggerDistanceIndex = closestLocations.findIndex(
        closestLocation => currentDistance < getLocationDistance(closestLocation, targetLocation),
      );

      if (biggerDistanceIndex < 0) return closestLocations;

      return [
        ...closestLocations.slice(0, biggerDistanceIndex),
        {
          ...location,
          distanceInKm: getDistanceToTarget(targetLocation, location),
        },
        ...closestLocations.slice(biggerDistanceIndex + 1),
      ];
    },
    [...locationsWithoutTarget],
  );
}

function getClosestLocationsByDistance(locations, targetLocation, distanceInKm = 20) {
  const allLocationsWithDistanceToTarget = updateLocationsWithDistancesToTarget(locations, targetLocation);
  // show all locations within provided distance from the searched location
  const locationsWithinClosestDistance = allLocationsWithDistanceToTarget.filter(
    location => location.distanceInKm <= distanceInKm,
  );

  const locationsSortedByDistance =
    locationsWithinClosestDistance.length === 0
      ? allLocationsWithDistanceToTarget.sort((a, b) => a.distanceInKm - b.distanceInKm).slice(0, 3) // if there is no location within provided, show the closest 3 locations
      : locationsWithinClosestDistance.sort((a, b) => a.distanceInKm - b.distanceInKm);

  return locationsSortedByDistance;
}

function getNumberOfClosestLocations(locations, targetLocation, numberOfLocations = 3) {
  return updateLocationsWithDistancesToTarget(locations, targetLocation)
    .sort((a, b) => a.distanceInKm - b.distanceInKm)
    .slice(0, numberOfLocations);
}

export { getClosestLocationsByDistance, getNumberOfClosestLocations };
